<template>
  <div>
    <v-select
      :items="getTradingRoles"
      :value="getSelectedTradingRole"
      v-model="selectedRole"
      @input="update()"
      label="Change Role:"
    ></v-select>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'TradingRoleSelector',
  computed: {
    ...mapGetters(['getTradingRoles', 'getSelectedTradingRole']),
  },
  watch: {
    getSelectedTradingRole: {
      handler(val) {
        this.selectedRole = val
      },
    },
  },
  data() {
    return {
      selectedRole: null,
    }
  },
  mounted() {
    this.selectedRole = this.getSelectedTradingRole
  },
  methods: {
    update() {
      this.$store.dispatch('setSelectedTradingRole', this.selectedRole)
      this.$emit('selected')
    },
  },
}
</script>
